import { render } from "./Attentions.vue?vue&type=template&id=3d446eed&scoped=true"
import script from "./Attentions.vue?vue&type=script&lang=js"
export * from "./Attentions.vue?vue&type=script&lang=js"

import "./Attentions.vue?vue&type=style&index=0&id=3d446eed&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d446eed"]])

export default __exports__